import { ElCollapseItem } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useEnvStore, useGlobalEventStore, useLanguageStore, useResponsive } from 'store'
import { deepClone, toCamelCase } from 'utils'
import { type FunctionalComponent } from 'vue'
import { footerOtherTextEntries } from '../lang-entries'

const platform = import.meta.env.VITE_PLATFORM

export const FooterOtherOverride: FunctionalComponent = () => {
  const { t } = useI18n()
  const responsive = useResponsive()
  const envStore = useEnvStore()
  const languageStore = useLanguageStore()
  const globalEventStore = useGlobalEventStore()

  const isMobile = computed(() => {
    return responsive.isMobile
  })

  const getFooterArticleUrl = (item: ApiResponse.FooterArticleConfig) => {
    let url = item.url
    if (item.language) {
      const key = toCamelCase(`url_${languageStore.currentLanguage}`)
      url = item.language[key]
    }
    return url || item.url
  }

  /** 关于我们 */
  const others = computed(() => {
    const list = deepClone(envStore.config?.others || [])
    if (platform === 'topcredit') {
      // TODO: 傻逼需求，others的后端动态返回，现在要前端在后面补2个就算了， 还要控制排序
      if (list.length === 0) {
        return list.concat([
          {
            title: '在线客服',
            url: 'customerService',
          },
          {
            title: '意见反馈',
            url: 'customerService', // 同样打开客服
          },
        ])
      } else {
        list.splice(1, 0, {
          title: '在线客服',
          url: 'customerService',
        })
        list.push({
          title: '意见反馈',
          url: 'customerService', // 同样打开客服
        })
      }
      return list
    }
    return list
  })

  const openOtherLink = (item: ApiResponse.FooterArticleConfig) => {
    if (item.url === 'customerService') {
      globalEventStore.onToggleServe()
      return
    }
    const url = getFooterArticleUrl(item)
    window.open(url, '_blank')
  }

  if (!isMobile.value) {
    return (
      others.value.length > 0 && (
        <div class="others link-list">
          <div class="title">{t(footerOtherTextEntries)}</div>
          <div class="content">
            {others.value.map((item) => (
              <div class="item">
                <div class="link" onClick={() => openOtherLink(item)}>
                  {t(item.title)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )
    )
  }
  return (
    <ElCollapseItem name={'3'}>
      {{
        title: () => <div class={'us-title'}>{t(footerOtherTextEntries)}</div>,
        default: () => (
          <div class={'us-content'}>
            {others.value.map((item) => (
              <div class="us-content-item">
                <div class="link" onClick={() => openOtherLink(item)}>
                  {t(item.title)}
                </div>
              </div>
            ))}
          </div>
        ),
      }}
    </ElCollapseItem>
  )
}
